import { Trans, useLingui } from "@lingui/react";
import { WIcon } from "@mobility-item-page/client";
import type { WarpModal } from "@warp-ds/elements/modal";
import { Button } from "@warp-ds/elements/react/button";
import { Modal, ModalFooter, ModalHeader } from "@warp-ds/elements/react/modal";
import { type Ref, useImperativeHandle, useRef } from "react";

export type ReserveCarInfoModalHandle = {
  open: () => void;
};

export const ReserveCarInfoModal = ({ ref }: { ref?: Ref<ReserveCarInfoModalHandle> }) => {
  const modalRef = useRef<WarpModal>(null);
  const { i18n } = useLingui();

  useImperativeHandle(ref, () => ({
    open: () => {
      modalRef.current?.open();
    },
  }));

  const handleClose = () => modalRef.current?.close();

  return (
    <Modal ref={modalRef}>
      <ModalHeader
        slot="header"
        title={i18n.t({
          id: "dealer.dcbPopup.title",
          message: "Reserve the car – how it works",
        })}
      />
      <div slot="content">
        <ul className="space-y-4">
          <li className="flex items-start gap-10 pb-8">
            <span className="ml-8 mt-2">
              <WIcon name="ArrowRight" />
            </span>
            <p className="text-base m-0">
              <Trans id="dealer.dcbPopup.detail1" message="Reserve the car for up to 48 hours at no cost." />
            </p>
          </li>
          <li className="flex items-start gap-10 pb-8">
            <span className="ml-8 mt-2">
              <WIcon name="ArrowRight" />
            </span>
            <p className="text-base m-0">
              <Trans id="dealer.dcbPopup.detail2" message="Fill in your details including personal number." />
            </p>
          </li>
          <li className="flex items-start gap-10 pb-8">
            <span className="ml-8 mt-2">
              <WIcon name="ArrowRight" />
            </span>
            <p className="text-base m-0">
              <Trans id="dealer.dcbPopup.detail3" message="Verify with BankID." />
            </p>
          </li>
          <li className="flex items-start gap-10 pb-8">
            <span className="ml-8 mt-2">
              <WIcon name="ArrowRight" />
            </span>
            <p className="text-base m-0">
              <Trans
                id="dealer.dcbPopup.detail4"
                message="The dealer receives your reservation and calls you within 24 hours during normal opening hours."
              />
            </p>
          </li>
          <li className="flex items-start gap-10 pb-8">
            <span className="ml-8 mt-2">
              <WIcon name="ArrowRight" />
            </span>
            <p className="text-base m-0">
              <Trans id="dealer.dcbPopup.detail5" message="Together you plan the next step in your buying process." />
            </p>
          </li>
        </ul>
      </div>
      <ModalFooter slot="footer">
        <Button variant="utility" fullWidth onClick={handleClose}>
          <Trans id="dealer.dcbPopup.close" message="Close" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};
